// const state = {}

// ==================================================
// INITIALIZERS
// ==================================================

function setDefaultState() {
    // set default state
}

function setListeners() {
    // set listeners
}

// ==================================================
// HANDLERS
// ==================================================

// ==================================================
// HELPERS
// ==================================================

// ==================================================
// INIT
// ==================================================

function init() {
    setDefaultState();
    setListeners();
}

export default init;
